import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { fetchViaProxy } from './proxy-fetch';
import { isEmpty, uniqBy } from 'lodash-es';

const fetchById = async ({ queryKey }) => {
  const { data, ok } = await fetchViaProxy(
    `/proxy/v1/nonprofits/${queryKey[1]}`,
    {
      method: 'GET',
    },
  );
  if (ok && data) {
    return data.data;
  }
  throw new Error('Error fetching non-profit');
};

const fetchRecommended = async () => {
  const { data, ok } = await fetchViaProxy(
    '/proxy/v2/protected/users/nonprofits/recommended',
    {
      method: 'GET',
    },
  );
  if (ok && data?.data) {
    const { company, user } = data.data;
    const list = uniqBy([...company, ...user], 'id').map((item) => ({
      ...item,
      isRecommended: true,
    }));
    return list;
  }
  return [];
};

const fetchUserCommunityReview = async ({ queryKey }) => {
  const { data, ok } = await fetchViaProxy(
    `/proxy/v2/protected/users/me/nonprofit/${queryKey[1]}/review`,
    {
      method: 'GET',
    },
  );
  if (ok && data?.data) {
    return data.data;
  }
  return null;
};


const fetchCommunityRating = async ({ queryKey }) => {
  const { data, ok } = await fetchViaProxy(
    `/proxy/v2/protected/nonprofits/${queryKey[1]}/rating`,
    {
      method: 'GET',
    },
  );
  if (ok && data?.data) {
    return data.data.rating;
  }
  return null;
};

export const useGetAllRecommendedNonProfits = () => {
  return useQuery({
    queryKey: ['recommended-non-profits'],
    queryFn: fetchRecommended,
    staleTime: 4 * 60 * 60 * 1000, // 4 hours
    refetchInterval: 4 * 60 * 60 * 1000, // 4 hours
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
  });
};

export const useGetNonProfitById = (id) => {
  return useQuery({
    queryKey: ['nonprofits', id],
    queryFn: fetchById,
    staleTime: 4 * 60 * 60 * 1000, // 4 hours
    refetchInterval: 4 * 60 * 60 * 1000, // 4 hours
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
  });
};

export const useGetUserCommunityReview = (id, laoding, communityRating) => {
  return useQuery({
    queryKey: ['user-community-review', id, laoding, communityRating],
    queryFn: fetchUserCommunityReview,
    staleTime: 4 * 60 * 60 * 1000, // 4 hours
    refetchInterval: 4 * 60 * 60 * 1000, // 4 hours
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
  });
};

export const useGetCommunityRating = (id) => {
  return useQuery({
    queryKey: ['community-rating', id],
    queryFn: fetchCommunityRating,
    staleTime: 4 * 60 * 60 * 1000, // 4 hours
    refetchInterval: 4 * 60 * 60 * 1000, // 4 hours
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
  });
};

